import React from "react";
import styles from "../assets/improveYourVoid.module.css";

const ImproveYourVoid = () => {
  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.titleSection}>
            <h3 className={styles.mainTitle}>
              Transforming Derelict Properties into Assets
            </h3>
          </div>

          <div className={styles.description}>
            <p>
              At Global Guardians, we specialize in revitalizing void
              properties, transforming them from derelict and distressed states
              into valuable assets for property owners and communities. Our
              comprehensive void property improvement solutions encompass
              maintenance, clearance, and deep cleaning services, ensuring that
              your property is restored to its full potential.
            </p>
          </div>

          <div className={styles.whyChooseSection}>
            <h3 className={styles.categoryTitle}>
              Why Choose Global Guardians?
            </h3>

            <div className={styles.featuresRow}>
              <div className={styles.featureCard}>
                <h4 className={styles.featureTitle}>Expertise</h4>
                <p className={styles.featureDescription}>
                  With years of experience in property management and
                  renovation, we have the expertise to breathe new life into
                  void properties of all sizes and conditions.
                </p>
              </div>

              <div className={styles.featureCard}>
                <h4 className={styles.featureTitle}>Comprehensive Services</h4>
                <p className={styles.featureDescription}>
                  From initial assessment to final cleanup, we offer a complete
                  range of services to address all aspects of void property
                  improvement, including maintenance, clearance, and deep
                  cleaning.
                </p>
              </div>

              <div className={styles.featureCard}>
                <h4 className={styles.featureTitle}>
                  Cost-Effective Solutions
                </h4>
                <p className={styles.featureDescription}>
                  Our cost-effective approach to property improvement maximizes
                  value for property owners while minimizing expenses, allowing
                  you to achieve a high return on investment.
                </p>
              </div>

              <div className={styles.featureCard}>
                <h4 className={styles.featureTitle}>Community Impact</h4>
                <p className={styles.featureDescription}>
                  By revitalizing void properties, we contribute to the
                  revitalization of communities, creating safer and more
                  attractive environments for residents and businesses alike.
                </p>
              </div>
            </div>
          </div>

          <div className={styles.servicesSection}>
            <div className={styles.titleSection}>
              <h3 className={styles.mainTitle}>Our Services</h3>
            </div>

            <div className={styles.serviceCategory}>
              <h3 className={styles.categoryTitle}>Maintenance</h3>

              <div className={styles.servicesRow}>
                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>Property Assessment</h4>
                  <p className={styles.serviceDescription}>
                    We conduct thorough assessments of void properties to
                    identify maintenance needs and develop tailored improvement
                    plans.
                  </p>
                </div>

                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>
                    Repairs and Renovations
                  </h4>
                  <p className={styles.serviceDescription}>
                    Our team handles all necessary repairs and renovations, from
                    minor fixes to major structural upgrades, to ensure that the
                    property is safe, functional, and aesthetically pleasing.
                  </p>
                </div>

                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>Routine Maintenance</h4>
                  <p className={styles.serviceDescription}>
                    We provide ongoing maintenance services to keep the property
                    in optimal condition, preventing deterioration and
                    minimizing future repair costs.
                  </p>
                </div>
              </div>
            </div>

            <div className={styles.serviceCategory}>
              <h3 className={styles.categoryTitle}>Clearance</h3>

              <div className={styles.servicesRow}>
                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>Site Clearance</h4>
                  <p className={styles.serviceDescription}>
                    We clear out debris, rubbish, and unwanted materials from
                    void properties, restoring them to a clean and tidy state.
                  </p>
                </div>

                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>Waste Disposal</h4>
                  <p className={styles.serviceDescription}>
                    Our team manages waste disposal in an environmentally
                    responsible manner, recycling materials whenever possible
                    and disposing of hazardous waste safely and legally.
                  </p>
                </div>

                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>Vegetation Management</h4>
                  <p className={styles.serviceDescription}>
                    We address overgrown vegetation and landscaping issues to
                    enhance the curb appeal and safety of the property.
                  </p>
                </div>
              </div>
            </div>

            <div className={styles.serviceCategory}>
              <h3 className={styles.categoryTitle}>Deep Cleaning</h3>

              <div className={styles.servicesRow}>
                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>Thorough Cleaning</h4>
                  <p className={styles.serviceDescription}>
                    We perform deep cleaning services to remove dirt, grime, and
                    odors from void properties, ensuring a fresh and welcoming
                    environment for future occupants.
                  </p>
                </div>

                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>Sanitization</h4>
                  <p className={styles.serviceDescription}>
                    Our deep cleaning services include sanitization of surfaces
                    and fixtures to eliminate bacteria, viruses, and other
                    contaminants, creating a healthier indoor environment.
                  </p>
                </div>

                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>Specialized Cleaning</h4>
                  <p className={styles.serviceDescription}>
                    We have the expertise and equipment to tackle specialized
                    cleaning tasks, such as mold remediation, graffiti removal,
                    and biohazard cleanup.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.contactSection}>
            <h4 className={styles.contactTitle}>Get in Touch</h4>
            <p className={styles.contactDescription}>
              Unlock the potential of your void properties with Global
              Guardians. Contact us today to learn more about our void property
              improvement solutions and discover how we can help you revitalize
              your assets.
            </p>
            <p className={styles.contactEmail}>
              Contact:{" "}
              <a href="mailto:clientcare@global-guardians.co.uk">
                clientcare@global-guardians.co.uk
              </a>{" "}
              and we will be happy to discuss your requirements.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImproveYourVoid;
